module.exports = "/_next/static/images/why-compensation-a251d888496bfedd3c9ef188efe62ee5.jpg";